export class State {
  filter: Record<string, any> = {};
}
